import { VehicletypeEnum } from "../../Enum/vehicle-type.enum";

export class FileIdReq{
    fileId : number;
}

export class AdminApprovalreq{
    approxCost:number
    approxDistance:number
    approvalDate:any
    vehicleReqId:number
    vehicleType:VehicletypeEnum
    veheicleId:number
    driverId:number
    driverContactNum:string
    vendorId:number
    role?:string
    user?:string
    remarks?:string
    slabId?:number
    totalHrs?:number
    type?:string
    vehicleCategory?:number
    status?:any



    constructor(
        approxCost?:number,
        approxDistance?:number,
        approvalDate?:any,
        vehicleReqId?:number,
       vehicleType?:VehicletypeEnum,
       veheicleId?:number,
       driverId?:number,
       driverContactNum?:string,
       vendorId?:number,
       role?:string,
       user?:string,
       remarks?:string,
       slabId?:number,
        totalHrs?:number,
        type?:string,
        vehicleCategory?:number,
        status?:any
    ){
        this.approxCost=approxCost
        this.approxDistance=approxDistance
        this.approvalDate=approvalDate
        this.vehicleReqId=vehicleReqId
        this.vehicleType=vehicleType
        this.veheicleId=veheicleId
        this.driverId=driverId
        this.driverContactNum=driverContactNum
        this.vendorId=vendorId
        this.role=role
        this.user=user
        this.remarks=remarks
        this.slabId=slabId
        this.totalHrs=totalHrs
        this.type=type
        this.vehicleCategory=vehicleCategory
        this.status=status
    }
}